(() => {
if (window.pbMobileDesignBound) return;
window.pbMobileDesignBound = true;
const mobile = window.matchMedia('(max-width:699px)');
const sync = section => {
  const open = section.dataset.pbDesignOpen === 'true';
  section.querySelectorAll('.pb-mobile-design-toggle').forEach(button => button.setAttribute('aria-expanded', String(!mobile.matches || open)));
  section.querySelectorAll('.pb-mobile-design-field').forEach(field => {
    field.inert = mobile.matches && !open;
  });
};
const sections = () => document.querySelectorAll('.shopify-section:has(.pb-mobile-design-toggle)');
document.addEventListener('click', event => {
  const button = event.target.closest('.pb-mobile-design-toggle');
  if (!button) return;
  const section = button.closest('.shopify-section');
  section.dataset.pbDesignOpen = String(section.dataset.pbDesignOpen !== 'true');
  sync(section);
});
document.addEventListener('invalid', event => {
  const section = event.target.closest('.shopify-section:has(.pb-mobile-design-toggle)');
  if (!section || !mobile.matches) return;
  section.dataset.pbDesignOpen = 'true';
  sync(section);
}, true);
mobile.addEventListener('change', () => sections().forEach(sync));
document.addEventListener('shopify:section:load', () => sections().forEach(sync));
const observer = new MutationObserver(records => {
  if (records.some(record => record.addedNodes.length)) sections().forEach(sync);
});
observer.observe(document.body, {childList:true, subtree:true});
sections().forEach(sync);
})();